import { toast } from "react-toastify";
import axiosInstance from "../../../../axios";

export const announcementQueryService = async (params) => {
  try {
    const response = await axiosInstance.get(`/announcement/`, { params });
    console.log("annoucnement response", response?.data?.payload);
    return response?.data?.payload;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const addNewAnnouncementService = async (payload) => {
  try {
    const response = await axiosInstance.post("/announcement", payload);
    console.log("response of add announcement", response?.data?.statusCode);
    if (response?.data?.statusCode === 200) {
      toast.success("Successfully Created !!!");
    }
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const ViewAnnouncementService = async (id) => {
  try {
    const response = await axiosInstance.get(`/announcement/${id}`);
    console.log("response of add announcement", response);
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getCoursesService = async () => {
  try {
    const response = await axiosInstance.get("/courses");
    console.log("response of courses -> ", response);
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getBatchesService = async (id) => {
  try {
    const response = await axiosInstance.get(`/batch?courseId=${id}`);
    console.log("response of courses -> ", response);
    return response;
  } catch (error) {
    console.log(error);
  }
};
